<template>
    <main-panel class="comment-ms">
        <template v-slot:header>
            <h2>{{$route.name}}</h2>
        </template>
        <component 
            v-for = "item in skeleton" 
            :key="item" 
            :admin="admin"
            :is="item.component_name"
            :type-tols="item.component_name"
            :params="item.params"
            :header="item.header"
            :url="item.url"/> 
    </main-panel>
</template>
<script>
import axios from 'axios';
import mainPanel from '../components/main/mainPanel.vue';
import components from '@/mixins/components.mixin.js';
export default{
    mixins:[components],
    components:{
        mainPanel,
    },
    mounted(){
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })
        this.getSkeleton(this.$route.fullPath.substring(1))
    },

    methods:{

    },
    data(){
        return{
            admin:false
        }
    }
}
</script>
<style>
    .comment-ms .main__body{
        display: flex;
        flex-direction: column;
        gap:60px
    }
    .comment-ms section:last-child{
        margin-bottom: 100px;
    }
    @media (max-width: 1000px){
        .comment-ms .main__body{
            gap: 0;
        }
    }
</style>